import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function SubscriptionSuccessPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const isTopup = !!sp.get('topup_id');
  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    const t = setInterval(() => setSeconds(s => {
      if (s <= 1) { clearInterval(t); navigate('/subscription'); }
      return s - 1;
    }), 1000);
    return () => clearInterval(t);
  }, [navigate]);

  return (
    <div style={{
      minHeight:'100vh', background:'#0C1220',
      display:'flex', alignItems:'center', justifyContent:'center',
      padding:24,
    }}>
      <div style={{
        background:'#fff', borderRadius:16, padding:'2.5rem 2rem',
        maxWidth:440, width:'100%', textAlign:'center',
        boxShadow:'0 24px 64px rgba(0,0,0,.2)',
      }}>
        <div style={{
          width:64, height:64, borderRadius:'50%',
          background:'#D1FAE5', display:'flex',
          alignItems:'center', justifyContent:'center',
          margin:'0 auto 20px',
        }}>
          <i className="ti ti-check" style={{fontSize:32, color:'#10b981'}} aria-hidden="true"/>
        </div>

        <h1 style={{fontSize:22, fontWeight:700, color:'#0F172A', marginBottom:8}}>
          Payment successful!
        </h1>

        <p style={{fontSize:14, color:'#475569', lineHeight:1.65, marginBottom:24}}>
          {isTopup
            ? 'Your top-up quotations have been credited to your account. You can continue running calculations immediately.'
            : 'Your plan has been upgraded successfully. Your new limits are now active.'}
        </p>

        <div style={{
          background:'#F8FAFC', border:'1px solid #E2E8F0',
          borderRadius:8, padding:'12px 16px', marginBottom:24,
          fontSize:13, color:'#64748B',
        }}>
          Redirecting to your subscription page in <strong style={{color:'#0F172A'}}>{seconds}</strong> seconds…
        </div>

        <button
          onClick={() => navigate('/subscription')}
          style={{
            background:'#0EA5E9', color:'#fff', border:'none',
            borderRadius:8, padding:'11px 24px', fontSize:14,
            fontWeight:600, cursor:'pointer', width:'100%',
            fontFamily:'inherit',
          }}>
          Go to subscription now
        </button>
      </div>
    </div>
  );
}